import type {
  BookingHostFilters,
  CheckboxFilterItem,
  FilterQuery,
  FiltersBase,
  Pagination,
} from 'types/filters';
import { isApplied } from '../utils/dynamicFilters';

export const filtersQueryBuilder = (filters: BookingHostFilters) => {
  const query: FilterQuery = {};

  const { keywordSearch, statuses } = filters;

  // The status filter is a two-item active/inactive pair, so the API takes the
  // truthiness of the applied item's value rather than the value itself.
  const getValue = (i: CheckboxFilterItem) => {
    return !!i.value;
  };

  if (keywordSearch) {
    query.search = keywordSearch;
  }

  if (statuses.filter(isApplied).length > 0) {
    query.active = statuses.filter(isApplied).map(getValue);
  }

  return query;
};

const sortByQueryBuilder = (sortBy: string) => {
  if (sortBy) {
    return { sortField: sortBy, sortDirection: 'asc' };
  }

  return {};
};

const paginationQueryBuilder = (
  { perPage, currentPage }: Pagination,
  { keywordSearch }: Pick<FiltersBase, 'keywordSearch'>
) => {
  if (keywordSearch) {
    return { perPage };
  }
  return { perPage, page: currentPage };
};

// Each part is omitted when its input is absent — most callers of
// `useBookingHosts` just want the unfiltered, unpaginated list.
const bookingHostsQueryBuilder = (
  filters?: BookingHostFilters,
  sortBy?: string,
  pagination?: Pagination
) => {
  return {
    ...(filters ? filtersQueryBuilder(filters) : {}),
    ...(sortBy ? sortByQueryBuilder(sortBy) : {}),
    ...(pagination
      ? paginationQueryBuilder(pagination, filters ?? { keywordSearch: '' })
      : {}),
  };
};

export default bookingHostsQueryBuilder;
